import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".vai-form {\n  box-sizing: border-box;\n  text-align: start;\n}\n.vai-form--centered {\n  margin: 0 auto;\n}";
styleInject(css_248z,{"insertAt":"top"});

export { css_248z as default };
